import { VARIANTS_ACTIONS } from '../contants';
import VariantSchema from '../../configs/APISchemas/Variant.schema';

export type PayloadType = {
  variantList?: VariantSchema[],
  isLoading?: boolean
}

export type ActionReturnType = {
  type: string;
  payload?: PayloadType
}

export const UpdateVariants = (
  variantList: VariantSchema[],
): ActionReturnType => {
  return {
    type: VARIANTS_ACTIONS.UPDATE,
    payload: { variantList: variantList, isLoading: false },
  };
};

export const SetLoading = (isLoading: boolean): ActionReturnType => {
  return {
    type: VARIANTS_ACTIONS.SET_LOADING,
    payload: { isLoading }
  }
}

export const ResetVariants = (): ActionReturnType => {
  return {
    type: VARIANTS_ACTIONS.RESET
  };
};



